import {
    GET_MEMBER_PROMOTIONS,
    GET_MEMBER_PROMOTIONS_ERROR,
    GET_MEMBER_PROMOTIONS_SUCCESS,
} from "core-web/state/models/User/constants";

import { acquireMutex } from "core-web/state";
import getMemberPromotionsEndpoint from "core-web/libs/GrebbCommerceAPI/promotions/getMemberPromotionsEndpoint";
import store from "core-web/state/store";

export const getMemberPromotions = (email) => async (dispatch) => {
    const mutexLock = await acquireMutex("user");
    dispatch({ type: GET_MEMBER_PROMOTIONS });

    try {
        const response = await getMemberPromotionsEndpoint(email);
        const status = await response.status();

        if (status !== 200) {
            throw "Could not get promotions";
        }

        const responseBody = await response.body();
        const promotions = responseBody.data || [];

        const formattedPromotions = promotions.map((promotion) => {
            const {
                id,
                name,
                expires_on: expiresOn,
                description,
                image_url: imageUrl,
                channels,
                value_type: valueType,
                value,
                local_values: localValues,
                instructions,
                link,
            } = promotion;

            return {
                id,
                name,
                expiresOn,
                description,
                imageUrl,
                channels,
                valueType,
                value,
                localValues,
                instructions,
                link,
            };
        });

        dispatch({ type: GET_MEMBER_PROMOTIONS_SUCCESS, promotions: formattedPromotions });

        mutexLock();
    } catch (error) {
        dispatch({ type: GET_MEMBER_PROMOTIONS_ERROR });

        mutexLock();

        console.error(error);
    }
};

export default (email) => store.dispatch(getMemberPromotions(email));
